import { Component } from "react";
import EditButton from "../ui/button/EditButton";
import RectButton from "../ui/button/RectButton";
import CheckBox from "../ui/CheckBox";
import SearchInput from "../ui/SearchInput";
import { ReactComponent as TrashIC } from "../assets/icons/trash-ic.svg";

import "./style.scss";
import AppContext from "../../contexts/AppContext";
import AddNewRecipientPopup from "../Popup/AddNewRecipientPopup";
import EditAddressPopup from "../Popup/AddNewRecipientPopup";

class Book extends Component {
    static contextType = AppContext;

    state = {
        selectedCount: 0,
        searchingName: null
    }

    selectAllHandler = (e) => {
        let check = this.state.selectedCount!==this.rows.length;
        let checks = this.table.querySelectorAll("input[type=checkbox]");
        checks.forEach(element => {
            element.checked = check;
        });
        this.onChangeHandler();
    }

    onChangeHandler = (e) => {
        let checks = this.table.querySelectorAll("input[type=checkbox]");
        let selectedCount = 0;
        checks.forEach(element => {
            if (element.checked) selectedCount++;
        });
        this.setState({ selectedCount: selectedCount });
    }

    searchHandler = (e) => {
        this.setState({ searchingName: e.target.value });
    }

    render() {
        let rows = [];
        this.props.children.forEach((item, i) => {
            let row = (!this.state.searchingName || item.name.toLowerCase().indexOf(this.state.searchingName.toLowerCase())>-1) ? <div className="row lock" key={`book-${i}`}>
                <div className="data">
                    <CheckBox label={item.name} onChange={this.onChangeHandler} />
                    <div>{item.address}</div>
                </div>
                {this.props.editing ? <div className="action"><EditButton onClick={() => this.context.setPopup(<EditAddressPopup edit={true} />)} /></div> : null}
            </div> : null;
            if(row) rows.push(row);
        })

        this.rows = rows;

        return (
            <>
                <div className={`addrs-book ${this.props.className || ""}`}>
                    <div className="action-bar row lock">
                        <div className="row lock actions">
                            <RectButton className="select-all-bt" text={this.state.selectedCount!==rows.length ? "SELECT ALL" : "DE-SELECT ALL"} onClick={this.selectAllHandler} />
                            <RectButton className="add-new-bt" text="ADD NEW" onClick={() => this.context.setPopup(<AddNewRecipientPopup />)} />
                            {this.props.editing ? <RectButton className="delete-bt" text="DELETE" disabled={true} icon={<TrashIC />} /> : null}
                        </div>
                        <SearchInput onChange={this.searchHandler} />
                    </div>

                    <div className="selection-book">
                        <div className="selected-count">({this.state.selectedCount} Selected)</div>
                        <div className="scroll-container">
                            <div className="table full" ref={el => (this.table = el)}>
                                { (rows && rows.length) ? rows : <div className="row">Not found</div> }
                            </div>
                        </div>
                    </div>
                </div>
            </>
        )
    }
}

export default Book;